








import { computed } from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  props: ["entity_name", "info_type_name", "selected_sensitivity"],
  setup(props) {
    const calculated_status_text = computed(() => {
      const { info_type_name, entity_name, selected_sensitivity } = props;
      console.log("selected_sensitivity::", selected_sensitivity);
      switch (Number.parseInt(selected_sensitivity as string)) {
        case 3:
          return `${entity_name} will be trusted with <b>all</b> ${info_type_name} data`;
        case 2:
          return `${entity_name} will be trusted with <b>all medium</b> sensitivity ${info_type_name} data and below`;
        case 1:
          return `${entity_name} will be trusted with <b>all low</b> sensitivity ${info_type_name} data and below`;
        case 0:
          return `${entity_name} will be trusted with <b>only</b> ${info_type_name} data that has no sensitivity`;
        default:
          return `${entity_name} will be treated as <b>unmanaged</b> in regards to ${info_type_name} data`;
      }
    });

    // the object will be untrusted with highly sensitivity and trusted with medium and low sensitivity
    return {
      calculated_status_text,
    };
  },
});
